<script>
import { isMobileMixin } from '@src/mixins/isMobileMixin'
import ResizeObserver from 'resize-observer-polyfill'

export default {
  mixins: [isMobileMixin],
  mounted() {
    this.resizeObserver = new ResizeObserver(this.handleResize)

    this.resizeObserver.observe(this.$refs.iframeContainer)
  },

  beforeDestroy() {
    this.resizeObserver.unobserve(this.$refs.iframeContainer)
  },

  beforeCreate() {
    document.body.className = 'iframe'
  },

  methods: {
    handleResize(entries) {
      const entry = entries[0]
      const { height } = entry.contentRect
      window.parent.postMessage({ height }, '*')
    },
  },
}
</script>

<template>
  <div ref="iframeContainer" @resize="handleResize">
    <slot />
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
